import Layout from '@/layout/Layout.vue'
import { P } from '@/config/permissions'

const perm = [P.SERVICES.BROWSE_RENEWABLE, P.SERVICES.MANAGE]

const renouvelementRoutes = {
  path: '/renouvelement',
  component: Layout,
  name: 'Renouvèlement',  // pour le breadcrum  // ce mot possède deux orthographes correctes : renouvellement et renouvèlement. : https://dictionnaire.orthodidacte.com/article/orthographe-renouvellement
  meta: {
    title: 'Renouvèlement',
    permissions: perm,
  },

  // no submenu, because children.length == 1
  children: [
    // Accéder à la page de renouvèllement des services
    {
      path: '/renouvelement',
      component: () => import('@/views/renouvelement/DashRenouvelement'),
      // Pas de `noCache` : cet ecran relit le statut du renouvellement dans `activated()`,
      // hook qui ne se declenche que sous <keep-alive>. L'en sortir laisse le statut vide,
      // et le bouton Lancer cesse d'etre bloque quand un renouvellement tourne deja.
      meta: {
        title: 'Renouvèlement',
        icon: 'mdi:refresh',
        permissions: perm,
      },
    },
    {
      path: '/renewStatus',
      hidden: true,
      component: () => import('@/views/renouvelement/renewStatus'),
      // Pas de `noCache` : cet ecran recharge lui-meme ses donnees dans `activated()`,
      // hook qui ne se declenche que sous <keep-alive>. L'en sortir le laisse vide.
      meta: {
        permissions: perm,
      },
    }
  ],
}

export default renouvelementRoutes
